import { Box, Link, Typography } from "@drone-js/core";
import type { SiteMapLinkGroup as LinkGroup } from "libs/codegen/property-onboarding";
import type { FunctionComponent } from "react";
import { PartnerMarketingLayout } from "./PartnerMarketingLayout";
import { usePartnerMarketingModelValue } from "./partnerMarketingModelAtom";

const SiteMapLink: FunctionComponent<LinkGroup["list"][number]> = ({ text, link, target }) => (
    <Box as="li" key={text}>
        <Link
            href={link}
            target={target}
            data-testid="sitemap-link"
            data-element-name="footer-site-map-link"
            data-element-value={text}
        >
            <Typography variant="body-s">{text}</Typography>
        </Link>
    </Box>
);

export const SiteMapLinkGroup: FunctionComponent<LinkGroup> = ({ title, list }) => (
    <Box
        width="100%"
        qM={{ width: "calc(33.33% - 24px)" }}
        qL={{ width: "calc(20% - 24px)" }}
        key={title}
        data-testid="sitemap-link-group"
    >
        <Typography variant="body-default-strong" mb="12">
            {title}
        </Typography>
        <Box as="ul" listStyle="none" m="0" p="0" display="flex" flexDirection="column" gap="4">
            {list.map((link) => (
                <SiteMapLink key={link.text} {...link} />
            ))}
        </Box>
    </Box>
);

export const FooterSiteMap: FunctionComponent = () => {
    const { linkGroups } = usePartnerMarketingModelValue();

    return (
        <section id="footer-site-map-section">
            <Box backgroundColor="base.background" py="48">
                <PartnerMarketingLayout col={10} data-element-name="site-map-section">
                    <Box
                        display="flex"
                        justifyContent="space-evenly"
                        flexWrap="wrap"
                        gap="24"
                        qM={{ me: "-24", flexWrap: "nowrap" }}
                        qL={{ me: "0" }}
                    >
                        {linkGroups.map((group) => (
                            <SiteMapLinkGroup key={group.title} {...group} />
                        ))}
                    </Box>
                </PartnerMarketingLayout>
            </Box>
        </section>
    );
};
